import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Surveillant from './surveillant';
import SurveillantDeleteModal from './surveillant-delete-modal';
import SurveillantDetail from './surveillant-detail';
import SurveillantUpdate from './surveillant-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={SurveillantUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={SurveillantUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/details`} component={SurveillantDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={Surveillant} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/delete`} component={SurveillantDeleteModal} />
  </>
);

export default Routes;
